import Rellax from './rellax.min.js'
import { onCleanup } from './cleanup.js'

/**
 * Instancia Rellax sobre los `.rellax` de la página actual.
 *
 * Rellax se suscribe a scroll/resize de `window` y arranca un rAF propio, por
 * lo que sobrevive al reemplazo del `.transition-wrapper` reteniendo los nodos
 * ya destruidos. Se destruye en el cleanup, siempre: la versión anterior sólo
 * destruía la instancia previa cuando la página nueva TAMBIÉN tenía `.rellax`,
 * dejándola viva indefinidamente al navegar a una página sin parallax.
 *
 * @param {ParentNode} [container=document] Ámbito de búsqueda
 */
function customRellax (container = document) {
  destroyRellax()

  if (!container.querySelector('.rellax')) return

  window.rellaxInstance = new Rellax('.rellax', {
    center: true
  })

  onCleanup(destroyRellax)
}

/** Destruye la instancia viva, si la hay. */
function destroyRellax () {
  if (!window.rellaxInstance) return

  try {
    window.rellaxInstance.destroy()
  } catch (err) {
    console.error('[rellax] destroy falló:', err)
  }

  window.rellaxInstance = null
}

// Método público para refrescar Rellax
customRellax.refresh = function () {
  if (window.rellaxInstance) {
    window.rellaxInstance.refresh()
  }
}

// Método público para reinicializar completamente
customRellax.reinit = function () {
  customRellax()
}

export default customRellax
